import FloorPlanDetail from '../components/FloorPlanDetail';

export default function FloorPlan31TerracePage() {
  const floorPlanData = {
    id: '3-1-terrace',
    title: '3+1 Teraslı Örnek Daire',
    totalArea: '145 m²',
    rooms: '3 Yatak Odası + 1 Salon + Teras',
    image: '/plan-3-1-terrace.png',
    description: '3+1 Teraslı daire tipimiz, lüks ve konforun bir araya geldiği özel bir yaşam alanı sunar. Geniş teras alanı ile panoramik manzaranın tadını çıkarırken, iç mekanlarda da maksimum konfor ve ferahlık sizi bekliyor. Ana yatak odasına özel giyinme odası ve banyo, iki ayrı banyo, geniş salon ve modern mutfak ile hayalinizdeki eve kavuşun.',
    roomDetails: [
      { name: 'Salon', dimensions: '5.40 x 7.20 m', area: '38.88 m²' },
      { name: 'Mutfak', dimensions: '3.40 x 4.20 m', area: '14.28 m²' },
      { name: 'Ana Yatak Odası', dimensions: '4.20 x 5.00 m', area: '21.00 m²' },
      { name: 'Yatak Odası 1', dimensions: '3.60 x 4.00 m', area: '14.40 m²' },
      { name: 'Yatak Odası 2', dimensions: '3.40 x 3.80 m', area: '12.92 m²' },
      { name: 'Ana Banyo', dimensions: '2.60 x 3.20 m', area: '8.32 m²' },
      { name: 'Ebeveyn Banyosu', dimensions: '2.20 x 2.80 m', area: '6.16 m²' },
      { name: 'Giyinme Odası', dimensions: '2.40 x 3.00 m', area: '7.20 m²' },
      { name: 'Teras', dimensions: '4.00 x 9.50 m', area: '38.00 m²' },
      { name: 'Balkon', dimensions: '1.40 x 5.20 m', area: '7.28 m²' },
      { name: 'Koridor & Hol', dimensions: '-', area: '18.56 m²' }
    ],
    features: [
      'Geniş ve lüks teras alanı',
      'Panoramik şehir manzarası',
      'Çok geniş salon ve yemek alanı',
      'Ana yatak odasına özel giyinme odası',
      'İki ayrı banyo',
      'Üç konforlu yatak odası',
      'Açık mutfak konsepti',
      'Teras için özel aydınlatma',
      'Bol dolap alanları',
      'Merkezi ısıtma sistemi',
      'Yerden ısıtma',
      'Akıllı ev altyapısı',
      'Ses yalıtımı',
      'Isı yalıtımı',
      'Teras için su tesisatı'
    ]
  };

  return <FloorPlanDetail data={floorPlanData} />;
}